// Feature 16 — Same-View Capture Guide capture core.
// LOAD-BEARING: capture reads ONLY the live <video> element. The translucent move-in overlay is a
// separate DOM layer and is NEVER passed here, so it can never be composited into stored evidence.

// Draw the current live video frame to a fresh canvas. `videoEl` must be an HTMLVideoElement.
// No overlay image, no DOM node, no CSS layer is ever read.
export function drawVideoFrameToCanvas(videoEl) {
  if (!videoEl || !videoEl.videoWidth) throw new Error("camera-not-ready");
  const canvas = document.createElement("canvas");
  canvas.width = videoEl.videoWidth;
  canvas.height = videoEl.videoHeight;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height); // sole source: the video track
  return canvas;
}

// Produce a File from the live video frame, wrapped for the existing upload pipeline
// (deterministic safe filename + correct MIME, no fabricated EXIF, image bytes = camera frame only).
export function captureFrameToFile(videoEl) {
  return new Promise((resolve, reject) => {
    let canvas;
    try { canvas = drawVideoFrameToCanvas(videoEl); }
    catch (e) { return reject(e); }
    canvas.toBlob((blob) => {
      if (!blob) return reject(new Error("capture-failed"));
      const file = new File([blob], `capture-${Date.now()}.jpg`, { type: "image/jpeg" });
      resolve({ file, previewUrl: URL.createObjectURL(blob) });
    }, "image/jpeg", 0.92);
  });
}

export function stopStream(stream) {
  try { (stream?.getTracks?.() || []).forEach((t) => t.stop()); } catch { /* noop */ }
}
